import * as React from "react"

const Requests = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.75 1.5a.75.75 0 0 1 .743.648l.007.102v16.5a3.75 3.75 0 0 1-3.55 3.745l-.2.005H6A4.5 4.5 0 0 1 1.5 18a.75.75 0 0 1 .648-.743l.102-.007h1.5v-15a.75.75 0 0 1 .648-.743L4.5 1.5h17.25ZM15 18.75H3.096l.027.102a3.002 3.002 0 0 0 2.7 2.143L6 21l9.75.001a3.731 3.731 0 0 1-.742-2L15 18.75ZM21 3H5.25v14.249l10.5.001a.75.75 0 0 1 .723.55l.02.098.007.102v.75a2.25 2.25 0 0 0 4.495.154L21 18.75V3Zm-3.75 9a.75.75 0 0 1 .102 1.493l-.102.007H7.526a.75.75 0 0 1-.101-1.493L7.526 12h9.724Zm-3-3a.75.75 0 0 1 .102 1.493l-.102.007H7.526a.75.75 0 0 1-.101-1.493L7.526 9h6.724Zm-3-3a.75.75 0 0 1 .102 1.493l-.102.007H7.526a.75.75 0 0 1-.101-1.493L7.526 6h3.724Z"
      fill="#80B8EE"
    />
  </svg>
)

export default Requests;
